import type { IGlobalSearchStaticEntry } from "../types/global-search";
import { GLOBAL_SEARCH_PAGE_ENTRIES } from "./global-search-pages";
import { GLOBAL_SEARCH_SETTING_OPTION_ENTRIES } from "./global-search-setting-options";
import {
  GLOBAL_SEARCH_ORGANIZATION_TAB_ENTRIES,
  GLOBAL_SEARCH_PROFILE_TAB_ENTRIES,
} from "./global-search-settings-tabs";

// NOTE: NSAI-6584 — the static index both palettes search on the device with
// searchGlobalSearchStaticEntries: every page (and page tab), every settings
// tab and every settings control. Each platform supplies its own `t` and a
// TGlobalSearchGateResolver that answers every EGlobalSearchGate; an item's
// destination comes from getGlobalSearchItemTarget. Ids follow
// `page.<name>[.<tab>]`, `settings.<section>.<tab>` and
// `setting.<tab>.<setting id>`; synonyms live in the globalSearchIndex
// namespace under getGlobalSearchKeywordKey(id). Pages come first so a tie on
// score (same kind of hit) keeps the broader destination on top.
export const GLOBAL_SEARCH_STATIC_ENTRIES: readonly IGlobalSearchStaticEntry[] =
  [
    ...GLOBAL_SEARCH_PAGE_ENTRIES,
    ...Object.values(GLOBAL_SEARCH_PROFILE_TAB_ENTRIES),
    ...Object.values(GLOBAL_SEARCH_ORGANIZATION_TAB_ENTRIES),
    ...GLOBAL_SEARCH_SETTING_OPTION_ENTRIES,
  ];
